import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Checkbox, Modal, Progress, Steps, message } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import TopBarHome from "../components/TopBarHome";
import { getStatoPratica } from "../services/api";
import { SyncOutlined } from '@ant-design/icons';
import pusher from "../services/pusherConfig";
import { CONFIG } from '../services/config';
import TopBarHomeOperatore from "../components/TopBarHomeOperatore";
const { innerWidth, innerHeight } = window;
const feUrl = CONFIG.FE_URL

const OverviewScreen = () => {
    const navigate = useNavigate();
    const [stato, setStato] = useState();
    const [updateState, setUpdateState] = useState();
    const [progressPercent, setProgressPercent] = useState(0);
    const [showProgress, setShowProgress] = useState(false);
    const [progressStatus, setProgressStatus] = useState("active");
    const [errorMessage, setErrorMessage] = useState(null);
    const [showComplete, setShowComplete] = useState(false);
    const [showCurrentStep, setCurrentStep] = useState(null);



    useEffect(() => {
        listenBroadcast();
        fetchStato();
    }, [])

    const fetchStato = async () => {
        setUpdateState(true);
        const idPratica = localStorage.getItem('id_pratica');
        const token = localStorage.getItem('token');
        const data = {
            id_pratica: idPratica
        }
        getStatoPratica(data, token)
            .then((res) => {
                setStato(res);
                if (res.check_operatore) {
                    setShowProgress(true)
                    // listenBroadcast()
                }
                else {
                    setShowProgress(false)
                }
            })
            .catch((error) => {
                if (error == "Non Autorizzato") {
                    if (localStorage.getItem('tokenOperatore')) {
                        navigate('/operatore/' + localStorage.getItem('tokenOperatore'));
                    }
                    else {
                        if (localStorage.getItem("praticaTotem")) {
                            localStorage.removeItem('praticaTotem');
                            navigate('/homepage', { state: { isTotem: true } })
                        }
                        else {
                            navigate('/homepage');
                        }
                    }
                } else {
                    message.error(error);
                }
            })
            .finally(() => {
                setUpdateState();
            });
    };

    const listenBroadcast = () => {
        if (localStorage.getItem('tokenOperatore')) {
            setShowProgress(true)
            const idPratica = localStorage.getItem('id_pratica');
            try {
                let c = pusher.subscribe(idPratica);
                c.bind("updateProgressOperatore", function (data) {
                    let perc = Math.floor((data.step_eseguiti / data.tot_step) * 100);
                    setProgressPercent(perc)
                    setErrorMessage(null);
                    setProgressStatus("active");
                });

                c.bind("updateErrorOperatore", function (data) {
                    setProgressStatus("exception");
                    setErrorMessage(data.message);
                    setCurrentStep(null);
                });

                c.bind("operatoreComplete", function (data) {
                    // setShowProgress(false)
                    setShowComplete(true);
                    setCurrentStep(null);
                });

                c.bind("updateStepOperatore", function (data) {
                    setCurrentStep(data.step)
                })
            } catch (error) {
            }
        }
    };

    const goBack = () => {
        if (localStorage.getItem('tokenOperatore')) {
            navigate('/operatore/' + localStorage.getItem('tokenOperatore'));
        }
        else {
            if (localStorage.getItem("praticaTotem")) {
                localStorage.removeItem('praticaTotem');
                navigate('/homepage', { state: { isTotem: true } })
            }
            else {
                navigate('/homepage');
            }
        }
    };

    const goAzNext = () => {
        const url = feUrl + stato.numero_pratica;

        window.open(url, '_blank');
    }

    const clickOK = () => {
        setShowComplete(false)
        setShowProgress(false)
        fetchStato();
    }

    return (
        <TopBarHomeOperatore>
            <div className="pol-content" style={{ overflow: 'hidden' }}>
                {
                    showProgress ?
                        <>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', position: 'absolute', height: '100%', left: 0, right: 0, zIndex: 100000, backgroundColor: 'rgba(0,0,0,0.2)' }}>
                                <div
                                    style={{ color: '#003897', fontFamily: 'Poppins-SemiBold', margin: 15, fontSize: 18, textAlign: 'left' }}>
                                    Apertura {stato && stato.nome_pacchetto ? stato.nome_pacchetto : ''} del cliente {stato && stato.intestatario ? stato.intestatario : ''} in corso
                                    <br />
                                    L'operazione potrebbe richiedere qualche minuto, attendere prego.
                                </div>

                                {
                                    !showComplete ?
                                        <>
                                            {
                                                showCurrentStep &&
                                                <div
                                                    style={{ color: '#003897', fontFamily: 'Poppins-SemiBold', margin: 15, fontSize: 18, textAlign: 'center' }}>
                                                    Step In Corso: <br />
                                                    {showCurrentStep}
                                                </div>
                                            }

                                            <Progress type="circle" percent={progressPercent} status={progressStatus} />
                                            {
                                                errorMessage &&
                                                <>
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                                                        <span style={{ fontFamily: 'Poppins-SemiBold', fontSize: 20, color: 'red', textAlign: 'center' }}
                                                            dangerouslySetInnerHTML={{ __html: errorMessage }}
                                                        />
                                                    </div>
                                                    <Button
                                                        type="primary"
                                                        style={{ fontFamily: 'Poppins-SemiBold', fontSize: 16, height: 40, borderRadius: 20, backgroundColor: '#003897', borderWidth: 0, margin: 20 }}
                                                        onClick={goAzNext}>
                                                        Apri la pratica su AzNext
                                                    </Button>
                                                </>
                                            }

                                            <Button
                                                type="primary"
                                                style={{ fontFamily: 'Poppins-SemiBold', fontSize: 16, height: 40, borderRadius: 20, backgroundColor: '#003897', borderWidth: 0, margin: 20 }}
                                                onClick={goBack}>
                                                Torna all'Homepage
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                                                <span style={{ fontFamily: 'Poppins-SemiBold', fontSize: 20, textAlign: 'center' }}

                                                >
                                                    Pratica Completata, procedi a firmare i documenti
                                                </span>
                                            </div>
                                            <Button
                                                type="primary"
                                                style={{ fontFamily: 'Poppins-SemiBold', fontSize: 16, height: 40, borderRadius: 20, backgroundColor: '#003897', borderWidth: 0, margin: 20 }}
                                                onClick={clickOK}>
                                                OK
                                            </Button>
                                        </>

                                }
                            </div>
                        </>
                        :
                        <>
                            {innerWidth < 500 ? (
                                <div style={{
                                    padding: '20px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <div
                                        style={{ color: '#003897', fontFamily: 'Poppins-SemiBold', margin: 15, fontSize: 18, textAlign: 'left' }}>
                                        Stato pratica numero {stato && stato.numero_pratica ? stato.numero_pratica : <div style={{ marginLeft: 10 }}><LoadingOutlined style={{ fontSize: "12px", color: "#2574f2" }} /></div>}
                                    </div>
                                    <div
                                        onClick={() => fetchStato()}
                                        style={{
                                            borderRadius: 16,
                                            height: 43,
                                            padding: 20,
                                            backgroundColor: '#EFF4FD',
                                            cursor: 'default',
                                            boxShadow: '1px 2px 9px #d4d4d4',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: 10
                                        }}
                                    >
                                        {updateState &&
                                            <div style={{ margin: 10 }}>
                                                <LoadingOutlined style={{ fontSize: "20px", color: "#2574f2" }} />
                                            </div>
                                        }

                                        {!updateState &&
                                            <div
                                                style={{
                                                    color: '#0A69E8', fontFamily: 'Poppins-SemiBold', fontSize: 16, textAlign: 'center', cursor: 'pointer'
                                                }}
                                            >{stato && stato.descrizione_stato ? stato.descrizione_stato : <div style={{ margin: 10 }}>
                                                <LoadingOutlined style={{ fontSize: "20px", color: "#2574f2" }} />
                                            </div>}
                                                {/* <SyncOutlined style={{  }} spin={updateState} onClick={() => fetchStato()} /> */}
                                            </div>}
                                    </div>
                                    {stato && stato.numero_step && stato.step_firma && (stato.step_firma <= stato.numero_step) &&
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }} >
                                            <Button
                                                type="primary"
                                                style={{
                                                    backgroundColor: '#2574F2',
                                                    height: '35px',
                                                    width: '185px',
                                                    borderRadius: '6px',
                                                    fontFamily: 'Poppins-SemiBold',
                                                    fontSize: '13px',
                                                    margin: '20px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}
                                                onClick={() => {
                                                    navigate('/documenti');
                                                }}
                                            >
                                                VAI AI TUOI DOCUMENTI
                                            </Button>
                                        </div>
                                    }
                                    <div
                                        style={{ color: '#003897', fontFamily: 'Poppins-Regular', fontSize: 16, margin: 10, textAlign: 'left', marginTop: 80 }}>
                                        In questa sezione potrai tenere sotto controllo lo stato della tua richiesta
                                    </div>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '4%', marginBottom: '7%', marginLeft: '8%', marginRight: '8%' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>

                                        <div style={{ display: 'flex', flexDirection: 'column', margin: 20 }}>
                                            <div
                                                style={{ color: '#003897', fontFamily: 'Poppins-SemiBold', margin: 15, fontSize: 22, textAlign: 'left' }}>
                                                Stato pratica:
                                            </div>
                                            <div
                                                style={{ color: '#003897', fontFamily: 'Poppins-Regular', fontSize: 18, margin: 15, textAlign: 'left' }}>
                                                In questa sezione potrai tenere sotto controllo lo stato della tua richiesta
                                            </div>
                                            <div
                                                style={{ color: '#003897', fontFamily: 'Poppins-Regular ', fontSize: 18, margin: 15, textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                Pratica numero: {stato && stato.numero_pratica ? stato.numero_pratica : <div style={{ marginLeft: 10 }}><LoadingOutlined style={{ fontSize: "22px", color: "#2574f2" }} /></div>}
                                            </div>

                                        </div>
                                        <div style={{ margin: 20, marginTop: '5%' }}>
                                            <div
                                                onClick={() => fetchStato()}
                                                style={{
                                                    // width: 360,
                                                    minWidth: 200,
                                                    height: 45,
                                                    padding: 25,
                                                    borderRadius: 15,
                                                    backgroundColor: '#EFF4FD',
                                                    cursor: 'default',
                                                    boxShadow: '1px 2px 9px #d4d4d4',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                {updateState &&
                                                    <div style={{ margin: 10 }}>
                                                        <LoadingOutlined style={{ fontSize: "30px", color: "#2574f2" }} />
                                                    </div>
                                                }

                                                {!updateState &&
                                                    <div
                                                        style={{
                                                            color: '#0A69E8', fontFamily: 'Poppins-SemiBold', fontSize: 22, textAlign: 'center', cursor: 'pointer'
                                                        }}
                                                    >{stato && stato.descrizione_stato ? stato.descrizione_stato : <div style={{ margin: 10 }}>
                                                        <LoadingOutlined style={{ fontSize: "30px", color: "#2574f2" }} />
                                                    </div>}
                                                        {/* <SyncOutlined style={{  }} spin={updateState} onClick={() => fetchStato()} /> */}
                                                    </div>}
                                            </div>
                                            {stato && stato.numero_step && stato.step_firma && (stato.step_firma <= stato.numero_step) &&
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }} >
                                                    <Button
                                                        type="primary"
                                                        style={{ backgroundColor: '#2574F2', height: 50, width: 220, borderRadius: 6, fontFamily: 'Poppins-SemiBold', fontSize: 14, margin: 20 }}
                                                        onClick={() => {
                                                            navigate('/documenti');
                                                        }}
                                                    >
                                                        VAI AI TUOI DOCUMENTI
                                                    </Button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )

                            }

                            {stato && !stato.steps ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <LoadingOutlined style={{ fontSize: "80px", color: "#2574f2" }} />
                            </div> :
                                <div style={{ width: '80%', marginLeft: '10%' }}>
                                    <Steps
                                        current={stato && stato.numero_step}
                                        status={stato && stato.status}
                                        items={stato && stato.steps}
                                    />
                                </div>
                            }

                            {stato && stato.testo_aggiuntivo &&
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5%' }}>
                                    <div
                                        style={{ color: '#003897', fontFamily: 'Poppins-Regular', fontSize: 25, margin: 15, textAlign: 'center' }}>
                                        {stato.testo_aggiuntivo}
                                    </div>
                                </div>
                            }

                            <div style={{ position: 'static', bottom: 30, marginLeft: '8%', marginRight: 15, marginTop: '1%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 20 }}
                                    onClick={() => {
                                        Modal.warning({
                                            title: 'Sei sicuro di voler tornare alla schermata iniziale?',
                                            content: 'Per verificare lo stato della pratica e visualizzare i tuoi documenti utilizza il codice pratica che ti è arrivato nella tua casella di posta',
                                            onOk: () => {
                                                if (localStorage.getItem('tokenOperatore')) {
                                                    navigate('/operatore/' + localStorage.getItem('tokenOperatore'));
                                                }
                                                else {
                                                    if (localStorage.getItem("praticaTotem")) {
                                                        localStorage.removeItem('praticaTotem');
                                                        navigate('/homepage', { state: { isTotem: true } })
                                                    }
                                                    else {
                                                        navigate('/homepage');
                                                    } localStorage.removeItem('id_pratica'); localStorage.removeItem('token')
                                                }
                                            },
                                            closable: true,
                                            maskClosable: true
                                        });
                                    }}>
                                    <div style={{ fontFamily: 'Poppins-Regular', fontSize: 16, color: '#0049EA', textDecoration: 'underline', margin: 15, marginTop: 40 }}>
                                        Torna alla homepage</div>

                                </div>
                            </div>
                        </>
                }


            </div>
        </TopBarHomeOperatore>
    );
};

export default OverviewScreen;
